import { render, staticRenderFns } from "./index.vue?vue&type=template&id=28c52506&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c52506",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28c52506')) {
      api.createRecord('28c52506', component.options)
    } else {
      api.reload('28c52506', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=28c52506&scoped=true", function () {
      api.rerender('28c52506', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ChangeLogistics/index.vue"
export default component.exports